<template>
  <a-modal
    :title="title"
    width="40%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    @cancel="handleCancel"
    @ok="submit"
    ok-text="确认"
    cancel-text="取消"
  >
    <div>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
      <!--prop="oneTarget"-->
        <a-form-model-item label="评审维度" >
          <a-input v-model="form.oneTarget" />
        </a-form-model-item>
        <a-form-model-item label="评价指标">
          <a-input v-model="form.twoTarget" />
        </a-form-model-item>
        <a-form-model-item label="评价要点" prop="content">
          <a-textarea
            v-model="form.content"
            placeholder="请输入评价要点"
            :auto-size="{ minRows: 4, maxRows: 6 }"
          />
        </a-form-model-item>
        <a-form-model-item label="分数" prop="score">
          <a-input-number
            style="width: 60px"
            id="inputNumber"
            v-model="form.score"
            :min="0"
          />
        </a-form-model-item>
        <a-form-model-item label="排序">
          <a-input-number
            style="width: 60px"
            id="inputNumber"
            v-model="form.sort"
          />
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>
  
<script>
import { postAction, putAction } from "@/api/index";
//oneTarget: [
//        {
//          required: true,
//          message: "请输入评审维度",
//          trigger: "blur",
//        },
//      ],
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      other: "",
      form: {
        name: "",
        region: undefined,
        date1: undefined,
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      rules: {
        content: [
          {
            required: true,
            message: "请输入评价要点",
            trigger: "blur",
          },
        ],
        score: [
          {
            required: true,
            message: "请输入分数",
            trigger: "blur",
          },
        ],
      },
      applyType: 4,
      // 添加还是编辑
      type: "",
      // 弹框标题
      title: "",
    };
  },
  methods: {
    init(type, applyType, record) {
      this.type = type;
      this.applyType = applyType;
      this.visible = true;
      if (type == "add") {
        this.form = {};
        this.title = "添加指标";
      } else {
        this.title = "编辑指标";
        record.content=String(record.content).replaceAll("\\n","\n");
        this.form = {
          oneTarget: record.oneTarget,
          twoTarget: record.twoTarget,
          content: record.content,
          score: record.score,
          sort: record.sort,
          id: record.id,
        };
      }
    },
    handleCancel() {
      this.visible = false;
    },
    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.visible = false;

          if (this.type == "add") {
            let params = this.form;
            params.applyType = this.applyType;
            params.content=String(this.form.content).replaceAll("\n","\\n");
            postAction("/lx/lxExpertItem/add", params).then((res) => {
              if (res.code == 200) {
                this.visible = false;
                this.$message.success("添加成功");
                this.$emit("addTarget");
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            let params = this.form;
            params.applyType = this.applyType;
            params.content=String(this.form.content).replaceAll("\n","\\n");
            putAction("/lx/lxExpertItem/edit", params).then((res) => {
              if (res.code == 200) {
                this.visible = false;
                this.$message.success("编辑成功");
                this.$emit("addTarget");
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .ant-modal-title {
  text-align: center;
}
/deep/ .ant-input-number-handler-wrap {
  display: none;
}
</style>
